// extracted by mini-css-extract-plugin
module.exports = {"container":"Landing_container__30Gcp"};